import React from 'react'
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";

import Col from "antd/lib/col";
import Row from "antd/lib/row";
import Table from 'antd/lib/table';
import Button from 'antd/lib/button';
import { EditOutlined, DeleteOutlined, GlobalOutlined } from "@ant-design/icons"

import DeleteModal from "./delete.modal"
import useWindowDimensions from "../hooks/useWindowDimensions";

const AdvertisementTable = ({ data, loading, onDelete }) => {
    const navigate = useNavigate();
    const { width } = useWindowDimensions();
    const [isOpen, setIsOpen] = React.useState(false);
    const [selected, setSelected] = React.useState(null);


    const open = (record) => {
        setIsOpen(true)
        setSelected(record)
    }
    
    const close = () => {
        setIsOpen(false);
        setSelected(null);
    }

    const desktopColumns = [
        {
            title: "Nombre",
            dataIndex: "name",
            align: "center",
            key: "name"
        },
        {
            title: "Visibilidad",
            dataIndex: "visibility",
            align: "center",
            key: "visibility",
            render: (visibility) => visibility ? 'Visible' : 'Oculto'
        },
        {
            title: "Formato",
            dataIndex: "type",
            align: "center",
            key: "type",
            render: (type) => type.toUpperCase()
        },
        {
            title: "Link",
            dataIndex: "link",
            align: "center",
            key: "link",
            render: (link) => <Icon href={link} rel="noreferrer" target='_blank'><GlobalOutlined /></Icon>
        },
        {
            title: "Acciones",
            align: "center",
            key: "actions",
            render: (record) => {
                return (
                    <div>
                        <Button onClick={() => navigate(`./${record.id}`)}  style={{marginRight: '8px'}}  shape="round" icon={<EditOutlined />}>
                            Editar
                        </Button>
                        <Button onClick={() => open(record)} shape="round" type='primary' danger icon={<DeleteOutlined />}>
                            Eliminar
                        </Button>
                    </div>
                )
            }
        }
    ]

    const mobileColumns = [
        {
            title: "Publicidad",
            align: "left",
            render: (record) => {

                return (
                <div>
                    <div>
                        <p><b>Nombre: </b>{record.name}</p>
                    </div>
                    <div>
                        <p><b>Visibilidad: </b>{record.visibility}</p>
                    </div>
                    <div>
                        <p><b>Formato: </b>{record.type.toUpperCase()}</p>
                    </div>
                    <div>
                        <p><b>Link: </b><a href={record.link} rel="noreferrer" target='_blank'><GlobalOutlined /></a></p>
                    </div>
                    <div style={{ width: '100%' }}>
                        <Button onClick={() => navigate(`./${record.id}`)}  style={{marginRight: '8px'}}  shape="round" icon={<EditOutlined />}>
                            Editar
                        </Button>
                        <Button onClick={() => open(record)} shape="round" type='primary' danger icon={<DeleteOutlined />}>
                            Eliminar
                        </Button>
                    </div>
                </div>
                )
            }
        }
    ]

    return (
        <Row style={{marginTop: '8px'}}>
            <Col span={24}>
                <Table 
                    rowKey="id"
                    loading={loading} 
                    columns={width > 510 ? desktopColumns : mobileColumns} 
                    dataSource={data} 
                />
                <DeleteModal 
                    open={isOpen} 
                    confirm={() => onDelete(selected)}
                    cancel={close}
                />
            </Col>
        </Row>
  )
}

export default AdvertisementTable

const Icon = styled.a`
    text-decoration: none;
    font-size: 20px;
`